import { AxiosInstance } from 'axios'

export function pinnedKnowledgeSpacesApiFactory(api: AxiosInstance) {
  const baseUrl = '/web/api/v2/pinned-knowledge-spaces'
  return {
    getPinnedKnowledgeSpaces() {
      return api.get<number[]>(baseUrl)
    },
    updatePinnedKnowledgeSpaces(ids: number[]) {
      return api.post<number[]>(baseUrl, ids)
    }
  }
}
